import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class DataService {

    private baseUrl = environment.baseUrl + "/data";

    constructor(public http: HttpClient) { }

    read(request): Observable<any> {
        return this.http.post(this.baseUrl + "/read", request);
    };

    readHistorical(request): Observable<any> {
        return this.http.post(this.baseUrl + "/read-historical", request);
    };

    dataPointsToSeries2(name, dataPoints, seriesByName?) {
        var seriesByName = seriesByName ? seriesByName : {};

        for (let i in dataPoints) {
            var datapoint = dataPoints[i];
            if (!seriesByName[datapoint.name]) {
                seriesByName[datapoint.name] = { order: i, name: datapoint.name, series: [] };
            }
            seriesByName[datapoint.name].series.push({ "name": name, "value": datapoint.value });
        }

        var seriesArray = [];
        Object.keys(seriesByName).forEach(key => seriesArray.push(seriesByName[key]));
        return seriesArray.sort((n1, n2) => n1.order - n2.order);
    };

    buildHistoricalQuery2(periodSize, periodTarget, tag) {
        var from = new Date();
        var to = new Date();

        let periodType = periodSize + "_" + periodTarget;

        // dia atual
        if (periodType == "DAY_CURRENT") {
            from.setHours(0, 0, 0, 0);
        }

        // dia anterior
        if (periodType == "DAY_PREVIOUS") {
            from.setDate(from.getDate() - 1);
            from.setHours(0, 0, 0, 0);
            to.setDate(to.getDate() - 1);
            to.setHours(23, 59, 59, 999);
        }

        // semana atual
        if (periodType == "WEEK_CURRENT") {
            from.setHours(0, 0, 0, 0);
            from.setDate(from.getDate() - from.getDay() + (from.getDay() == 0 ? -6 : 1));
            from.setDate(from.getDate() - 1);
        }

        // semana anterior
        if (periodType == "WEEK_PREVIOUS") {
            from.setHours(0, 0, 0, 0);
            from.setDate(from.getDate() - from.getDay() + (from.getDay() == 0 ? -6 : 1));
            from.setDate(from.getDate() - 8);
            to.setDate(from.getDate() + 6);
            to.setHours(23, 59, 59, 999);
        }

        // mes atual
        if (periodType == "MONTH_CURRENT") {
            from.setFullYear(from.getFullYear(), from.getMonth(), 1);
            from.setHours(0, 0, 0, 0);
        }

        // mes anterior
        if (periodType == "MONTH_PREVIOUS") {
            from.setFullYear(from.getFullYear(), from.getMonth() - 1, 1);
            from.setHours(0, 0, 0, 0);
            to.setFullYear(to.getFullYear(), to.getMonth(), 1);
            to.setDate(to.getDate() - 1);
            to.setHours(23, 59, 59, 999);
        }

        return { from: from, to: to, tag: tag };
    }
}
